export default "__VITE_ASSET__CkRVQ1$W__"